import HeaderAdmin from "./ManageUser/HeaderAdmin";
import MenuAdmin from "./Menu";
import SocialMediaIcons from "../../components/SocialMediaIcons";

const HomeAdmin = () => {
  return (
    <div>
      <HeaderAdmin />
      <MenuAdmin />
      <SocialMediaIcons />
    </div>
  );
};

export default HomeAdmin;
